import { createFileRoute, redirect } from '@tanstack/react-router';

import { newRecommendationsSearchSchema } from 'components/NewRecommendations';
import { isPersonAdmin } from 'helpers/query';

export const Route = createFileRoute(
  '/_private/_route/teams/$teamId/pipelines/$pipelineId_/recommendations/new',
)({
  validateSearch: newRecommendationsSearchSchema,
  beforeLoad: async ({ context, params }) => {
    const { user } = context;
    if (!isPersonAdmin(user)) {
      throw redirect({
        params: {
          pipelineId: params.pipelineId,
          teamId: params.teamId,
        },
        to: '/teams/$teamId/pipelines/$pipelineId/recommendations',
        replace: true,
      });
    }
  },
});
